// Una columna por dependiente, y otra para su estatus.
//
// ── LA QUEJA, Y POR QUE VUELVE ─────────────────────────────────────────────
//
// Lissette, 2026-09-01: "cuando pedimos dependiente y estatus migratorio no
// coloca todo en una sola columna, se puede separar dependiente tal y su
// estatus, dependiente tal y su estatus por columna?".
//
// Se hizo... a medias. Las doce columnas se escribieron en el RENDERIZADOR
// (ReportsClientsView.getResultColumns), que sabe pintarlas, pero NO en el
// SELECTOR (CustomReportsTab.makeColumnCatalog), que es donde se eligen. O sea
// que existian y no habia forma humana de pedirlas: la unica opcion de
// dependientes que ofrecia la pantalla seguia siendo la columna junta.
//
// Lissette, 2026-09-02: "sigo viendo los dependientes y sus estatus en una
// misma columna". Tenia razon.
//
// El propio archivo del selector lo advertia dos lineas mas arriba: "Every key
// here must have a matching renderer or the column is silently dropped". Se
// comprobo esa direccion y no la contraria.
//
// ── POR ESO ESTO EXISTE ────────────────────────────────────────────────────
//
// Las claves y las etiquetas se declaran UNA VEZ, aqui, y las leen los dos
// lados. Ya no pueden separarse, porque ya no son dos listas.

/**
 * SEIS es el tope, y es una decision, no un limite tecnico. El informe tiene un
 * numero FIJO de columnas -- no puede crecer segun el cliente que toque -- asi
 * que hay que elegir uno. Con seis cabe una familia grande; por encima, la
 * columna junta ("Migratorio (dependientes)") los sigue enseñando a todos, asi
 * que nadie pierde informacion, solo la comodidad de la rejilla.
 *
 * Si algun dia hace falta subirlo, hay que subir con el
 * TOPE_COLUMNAS_DESDE_INFORME del servidor: la prueba
 * hojaDesdeInformeCabenLasColumnas los tiene atados.
 */
export const TOPE_DEPENDIENTES = 6;

/** [{ i, claveNombre, claveEstatus }] — el orden en que salen en la tabla. */
export const COLUMNAS_DE_DEPENDIENTES = Array.from(
  { length: TOPE_DEPENDIENTES },
  (_, i) => ({
    i,
    claveNombre: `dep${i + 1}Name`,
    claveEstatus: `dep${i + 1}Status`,
  }),
);

/** Todas las claves, en orden. Sirve para comprobar que los dos lados cuadran. */
export const CLAVES_DE_DEPENDIENTES = COLUMNAS_DE_DEPENDIENTES
  .flatMap(({ claveNombre, claveEstatus }) => [claveNombre, claveEstatus]);

/** El nombre que ve la persona. Uno solo, para que no diverjan los dos lados. */
export function etiquetaDeDependiente(i, es) {
  return es ? `Dependiente ${i + 1}` : `Dependent ${i + 1}`;
}

export function etiquetaDeEstatusDeDependiente(i, es) {
  return es ? `Estatus dependiente ${i + 1}` : `Dependent ${i + 1} status`;
}
